'use client';

import { useEffect } from 'react';
import { Link } from '@/i18n/routing';

export default function ProductError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Product page error:', error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-[#fffaf4] px-4">
      <div className="max-w-md text-center">
        <h2 className="text-2xl font-black text-slate-900">Tijdelijk niet beschikbaar</h2>
        <p className="mt-3 text-slate-600">
          Dit product is tijdelijk niet bereikbaar. Ons team is op de hoogte.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={reset}
            className="rounded-full bg-rose-600 px-6 py-3 font-bold text-white hover:bg-rose-700"
          >
            Opnieuw proberen
          </button>
          <Link
            href="/"
            className="rounded-full border border-slate-300 bg-white px-6 py-3 font-bold text-slate-900 hover:bg-slate-50"
          >
            Naar homepage
          </Link>
        </div>
        {error.digest && (
          <p className="mt-4 text-xs text-slate-400">Ref: {error.digest}</p>
        )}
      </div>
    </div>
  );
}
